import React, { useEffect, useRef, useState } from "react";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import {
  Link,
  useNavigate,
  useLocation,
  useSearchParams,
} from "react-router-dom";
import {
  Input,
  ConfigProvider,
  Col,
  Row,
  Avatar,
  Skeleton,
  Tag,
  AutoComplete,
  Tooltip,
  Image,
  Modal,
  Button
} from "antd";
import {
  SearchOutlined,
  DownOutlined,
  UpOutlined,
  SmileFilled,
  LogoutOutlined,
  CloseOutlined,
  GlobalOutlined,
  ArrowLeftOutlined,
  MenuOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import history from "history/browser";
import useActions from "./hooks/useActions";

import { useDispatch, useSelector } from "react-redux";
import { setClRefetchJourney } from "../../redux/features/content_library/contentLibrarySlice";
import {
  setTextSearch,
  setSearchBarPosition,
} from "../../redux/features/main/searchSlice";

import Learningpoints from "../../assets/images/svgs/ic_learningpoints_programdesc.svg";
import WebLogo from "../../assets/images/svgs/ic_logo_general.svg";
import IProfile from "../../assets/images/custom_svgs/IProfile";
import ILogout from "../../assets/images/custom_svgs/ILogout";
import IChangePassword from "../../assets/images/custom_svgs/IChangePassword";
import IcTeamMember from "../../assets/images/svgs/ic_team_teammonitoring.svg";
import LogOut from "./LogOut/LogOut";
import ChangePassword from "./ChangePassword/ChangePassword";
import ModalSuccessCheck from "../ModalSuccessCheck";
import ModalPointHistory from "../../components/ModalPointHistory";
import ModalChangeLanguage from "../ModalChangeLanguage";
import { randColor, setLocalStorage, getLocalStorage, getUsername, getDataSso } from "../../utils";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import { setCollapsedMenuMobile } from "../../redux/features/main/localizationSlice";

// for translate
import { useTranslation } from "react-i18next";

// color config
import {
  colorPhotoProfileUserHeader,
  textSearchHeader,
  ColorSecondary,
  ColorPrimary,
  colorTextTitleMobile,
  teamMonitoringText,
  colorTextDesc,
  textTitleHome
} from "../../config/constant/color/index";

import { getTeamStatus, getModuleReviewed, RequestChangePassword } from "../../api/repositories";
import { setInvalidToken } from "../../redux/features/main/invalidTokenSlice";

// import styles
import styles from "./styles";
import SearchMobileLearningJourney from "../../pages/main/contents/LearningJourney/lib/SearchMobileLearningJourney";
import SearchMobileVersion from "../../pages/filter/Search/searchMobileVersion";
import { setShowDetailsModuleReview } from "../../redux/features/main/localizationSlice";

const HeaderContent = ({
  name,
  loadingHeader,
  position,
  points,
  picture,
  firstname,
  listJourney,
  academyNameHeader,
  mainState,
  email
}) => {
  const isCollectionCL = useSelector((state) => state.search.isCollectionCL);
  const remoteProperty = useSelector((state) => state.remote.remoteProperty);
  const collapsedMenuMobile = useSelector(
    (state) => state.localization.collapsedMenuMobile,
  );
  const titleDetailTeamMonitoringOnBoarding = useSelector(
    (state) => state.localization.titleDetailTeamMonitoringOnBoarding,
  );
  const loadingTitleDetailTeamMonitoringOnBoarding = useSelector(
    (state) => state.localization.loadingTitleDetailTeamMonitoringOnBoarding,
  );
  const dispatch = useDispatch();

  const { t, i18n } = useTranslation();
  const { Option } = AutoComplete;

  const [itemsSearchBar, setItemsSearchBar] = useState([]);

  const [value, setValue] = useState("");
  const [mouseOver, setMouseOver] = useState("");
  const [flagDropDown, setFlagDropDown] = useState(false);
  const [openModalLogout, setModalLogout] = useState(false);
  const [openModalPassword, setModalPassword] = useState(false);
  const [isOpenModalChangeLanguage, setIsOpenModalChangeLanguage] =
    useState(false);
  const [modalSuccessPassword, setModalSuccessPassword] = useState(false);
  // const [ randomColor, setRandomColor ] = useState()
  const [searchBarPage, setSearchBarPage] = useState("");
  const [isOpenPointHistory, setIsOpenPointHistory] = useState(false);
  const [isOpenTooltipToolbar, setIsOpenTooltipToolbar] = useState(false);
  const [tooltipMessage, setTooltipMessage] = useState("");
  const [isOpenSelect, setIsOpenSelect] = useState(false);
  const [valueSearch, setValueSearch] = useState("");
  let [searchParams, setSearchParams] = useSearchParams();
  const [isScallingVersion, setIsScallingVersion] = useState(false);
  // const [isShowRecentSearch, _setIsShowRecentSearch] = useState(false);
  const [loadingTeamLearningStatus, setLoadingTeamLearningStatus] =
    useState(false);
  const [totalDataTeamMember, setTotalDataTeamMember] = useState(0);
  const [isEmptyStatus, setIsEmptyStatus] = useState(true);
  const [loadingModuleReview, setLoadingModuleReview] = useState(false);
  const [titleModuleReview, setTitleModuleReview] = useState("");
  const [isOpenModalSentChangePassword, setIsOpenModalSentChangePassword] = useState(false);
  const mutation = useRef();

  const navigate = useNavigate();
  const location = useLocation();
  const locPathname = location.pathname;
  const queryParams = new URLSearchParams(location.search);
  const searchQuery = queryParams.get("search");
  const hasLengthParam = queryParams.has("length");
  const screens = useBreakpoint();
  const isMobileVersion = screens.xs || isScallingVersion;
  const locationFrom = location.state?.from || "/home";
  const hasSearchQuery = queryParams.has("search");
  const hasTeamMonitoringPath = locPathname.includes("team-monitoring");
  const isPageReviews = locPathname === "/reviews";

  const {
    handleLogoutPercipio,
    journeyId,
    journeyName,
    loading,
    pageName,
    contentLibraryAcademyHeader,
    handleFetchPointHistory,
    pointHistoryData,
    setPointHistoryData,
    dateModuleConvert,
  } = useActions({ loadingHeader, listJourney, setIsOpenPointHistory });

  const handleLogOutClick = () => {
    setModalLogout(!openModalLogout);
    handleLogoutPercipio();
  };

  const fetchTeamLearningStatus = async () => {
    try {
      setLoadingTeamLearningStatus(true);
      const { data, status } = await getTeamStatus({}, isMobileVersion);

      dispatch(setInvalidToken(status));
      if (status === 200) {
        setTotalDataTeamMember(data?.teams.length);
        setIsEmptyStatus(data?.teams.length > 0 ? false : true);
      }
    } catch (err) {
      console.log("Error fetch Team Learning Member " + err);
      setTotalDataTeamMember(0);
      setIsEmptyStatus(true);
    } finally {
      setLoadingTeamLearningStatus(false);
    }
  };

  useEffect(() => {
    // set the observer only if the path is not team monitoring
    // if (hasTeamMonitoringPath) {
    fetchTeamLearningStatus();
    // }
  }, []);

  const onSearch = (searchValue) => {
    setValue(searchValue);
  };

  const getMutation = () => {
    // define the target node
    var targetNode = document.querySelector("#header-dpd");

    const config = { attributes: true, attributeOldValue: true };

    // callback function
    const callback = function (mutationsList, observer) {
      if (targetNode.classList.contains("show") === false) {
        setFlagDropDown(false);
      }
    };

    // Create observer instance
    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);

    //set scalling header, it's work if after load observer only
    setIsScallingVersion(
      window.innerWidth < 992 && (window.innerHeight >= window.innerWidth || window.innerWidth > window.innerHeight)
    );
  };

  // const testImage = (URL) => {
  //     var tester=new Image();
  //     tester.onload=imageFound;
  //     tester.onerror=randomingColor;
  //     tester.src=URL;
  // }

  // const randomingColor = () => {
  //     setRandomColor(randColor());
  // }

  // const imageFound = () => {
  //     setRandomColor('none')
  // }

  const removeHighlight = () => {
    const urlTargeted = "/my-learning-journey/journey/" + journeyId;
    document
      .querySelectorAll("#id-title-course-collapsed")
      .forEach((e) => e.classList.remove("title-active"));
    document
      .querySelectorAll(".ant-steps-item")
      .forEach((e) => e.classList.remove("active-step"));

    navigateUrl(urlTargeted);
  };

  const backToAcademy = () => {
    const arrId = locPathname.split("/");
    if (
      locPathname.indexOf("content-library") > -1 &&
      locPathname.indexOf("course") > -1
    ) {
      const urlTargeted = `/content-library/academy/${parseInt(
        arrId[3],
      )}/journey/${parseInt(arrId[5])}`; // location journey Id
      dispatch(setClRefetchJourney(true));

      navigateUrl(urlTargeted);

      // for Header title purpose set title Academy
      mainState.setAcademyNameHeader("ACADEMY_" + mainState.currAcademy);
    } else {
      const urlTargeted = "/content-library/academy/" + parseInt(arrId[3]); // location academy Id

      navigateUrl(urlTargeted);
    }
  };

  const navigateUrl = (url) => {
    // navigate to Program Desc page
    // block url if on Stream Scorm Page
    history.replace(url);
    mainState.setPopupStream((prevState) => {
      return {
        ...prevState,
        url: url,
      };
    });
    if (mainState.popupStream.status === false) navigate(url);
  };

  const handlePointClicked = () => {
    handleFetchPointHistory();
  };

  const numberWithDot = (x) => {
    if (x !== null && x !== undefined) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }
  };

  // test commit

  useEffect(() => {
    if (flagDropDown === false) getMutation();
  }, [flagDropDown]);

  // useEffect(() => {
  //     if(name !== undefined) testImage(picture)
  // },[name])

  const handleSelectSearchBar = (value) => {
    setIsOpenSelect(false);

    dispatch(setTextSearch(value));
    setSearchParams({ search: value });
    dispatch(setSearchBarPosition(searchBarPage));

    // local Storage things to save, read, and set
    const historyValue =
      Array.isArray(getLocalStorage(searchBarPage)) === true
        ? getLocalStorage(searchBarPage)
        : JSON.parse(getLocalStorage(searchBarPage));

    const arrayHistory = historyValue,
      index = arrayHistory.findIndex((v) => v === value);

    if (index !== -1) arrayHistory.unshift(...arrayHistory.splice(index, 1));

    // trim array to only 5 history
    const trimArr =
      arrayHistory.length > 5 ? arrayHistory.slice(0, 5) : arrayHistory;

    setLocalStorage(searchBarPage, JSON.stringify(trimArr));
  };

  const deleteOption = (value) => {
    setItemsSearchBar(
      itemsSearchBar.filter((item) => {
        return item.value !== value;
      }),
    );
    let historySearchToDelete =
      Array.isArray(getLocalStorage(searchBarPage)) === true
        ? getLocalStorage(searchBarPage)
        : JSON.parse(getLocalStorage(searchBarPage));

    historySearchToDelete = historySearchToDelete.filter((e) => e !== value);

    setLocalStorage(searchBarPage, JSON.stringify(historySearchToDelete));
  };

  const handleOnSearch = (value) => {
    if ((value.length < 3 && value.length !== 0) || value.length >= 50) {
      setIsOpenTooltipToolbar(true);
      if (value.length < 3 && value.length !== 0) {
        setTooltipMessage(t("feature.feature_search.please_enter"));
      } else {
        setTooltipMessage(t("feature.feature_search.limit_char_reach"));
      }
    } else {
      setIsOpenTooltipToolbar(false);
    }
    setValueSearch(value);
  };

  const handleEnter = (value) => {
    // keyCode for button Enter
    if (value.keyCode === 13) {
      if (valueSearch.length >= 3) {
        // console.log("Enter !!");

        setIsOpenSelect(false);

        dispatch(setTextSearch(valueSearch));
        setSearchParams({ search: valueSearch });
        dispatch(setSearchBarPosition(searchBarPage));

        // local Storage things to save, read, and set
        const historySearchMylj =
          Array.isArray(getLocalStorage(searchBarPage)) === true
            ? getLocalStorage(searchBarPage)
            : JSON.parse(getLocalStorage(searchBarPage));

        if (historySearchMylj.indexOf(valueSearch) === -1) {
          historySearchMylj.unshift(valueSearch);
        }

        // trim array to only 5 history
        const trimArr =
          historySearchMylj.length > 5
            ? historySearchMylj.slice(0, 5)
            : historySearchMylj;

        setLocalStorage(searchBarPage, JSON.stringify(trimArr));
        if (itemsSearchBar.length === 0) setItemsSearchBar([...trimArr]);
      }
    }
  };

  const handleFocus = () => {
    if (itemsSearchBar.length > 0) {
      setIsOpenSelect(true);
      settingItemsSearch(getLocalStorage(searchBarPage));
    } else {
      setIsOpenSelect(false);
    }
  };

  const settingItemsSearch = (dataLocalStorage) => {
    const arryLocalStore =
      Array.isArray(dataLocalStorage) === true
        ? dataLocalStorage
        : JSON.parse(dataLocalStorage);

    const dataItemsSearch = [].concat(
      ...arryLocalStore.map((item, index) => {
        return {
          key: parseInt(index + 1),
          id: parseInt(index + 1),
          value: item,
          label: item,
        };
      }),
    );

    // console.log(dataItemsSearch)
    setItemsSearchBar([...dataItemsSearch]);
  };

  const checkTagName = (item) => {
    if (item === "ACADEMY") return t("feature.feature_cl.program_desc.academy");
    if (item === "PROGRAM")
      return t("feature.feature_cl.program_desc.program_cap");
  };

  useEffect(() => {
    if (searchBarPage !== "")
      settingItemsSearch(getLocalStorage(searchBarPage));
  }, [searchBarPage]);

  const historySearchCL = getLocalStorage("search_cl");

  useEffect(() => {
    if (!isMobileVersion) {
      const arrloc = locPathname.split("/");
      if (
        (arrloc.length === 2 && arrloc.indexOf("my-learning-journey") > -1) ||
        locPathname.indexOf("my-learning-journey/search") > -1
      ) {
        setSearchBarPage("search_mylj");
        dispatch(setSearchBarPosition("search_mylj"));
      } else if (
        (arrloc.length === 2 && arrloc.indexOf("content-library") > -1) ||
        locPathname.indexOf("content-library/search") > -1
      ) {
        if (isCollectionCL === false) {
          setSearchBarPage("search_cl");
          dispatch(setSearchBarPosition("search_cl"));
        } else {
          setSearchBarPage("");
          dispatch(setSearchBarPosition(""));
          setIsOpenTooltipToolbar(false);
        }
      } else {
        setSearchBarPage("");
        dispatch(setSearchBarPosition(""));
        setIsOpenTooltipToolbar(false);
      }
    }
  }, [location, isCollectionCL]);

  const labelHeaderMobileVersion = [
    `${t("main.sidebar.search_result")}`,
    `${t("main.sidebar.my_learning_journey")}`,
  ][!!searchQuery ? 0 : 1];

  // const [titleOnGoingTeamMonitoring, setTitleOnGoingTeamMonitoring] =
  //   useState("");
  // const getTitleOnGoingTeamMonitoring = localStorage.getItem("homeTitle");

  const headerWithoutHamburger =
    locPathname.includes("/team-monitoring/learning-status/detail") ||
    locPathname.includes("/team-monitoring/journey/") ||
    locPathname.includes("/team-monitoring/team-profile") ||
    locPathname.includes("team-monitoring/member/profile") ||
    locPathname.includes("reviews/module/");

  // useEffect(() => {
  //   if (
  //     isMobileVersion &&
  //     locPathname.includes("/team-monitoring/journey/")
  //   ) {
  //     console.log('titleDetailTeamMonitoringOnBoarding', titleDetailTeamMonitoringOnBoarding);
  //   }
  // }, [locPathname]);

  // useEffect(() => {
  //   if (titleOnGoingTeamMonitoring) {
  //     setTitleOnGoingTeamMonitoring(getTitleOnGoingTeamMonitoring);
  //   }
  // }, [titleOnGoingTeamMonitoring]);

  // console.log('getTitleOnGoingTeamMonitoring', getTitleOnGoingTeamMonitoring);
  // console.log('titleOnGoingTeamMonitoring', titleOnGoingTeamMonitoring);

  // const funcToSetIsShowRecentSearch = (v) => {
  //   mainState.setIsShowRecentSearch(v);
  //   // _setIsShowRecentSearch(v);
  // };

  const fetchListModuleReviewed = async () => {
    setLoadingModuleReview(true);

    try {
      const { data, status } = await getModuleReviewed();
      dispatch(setInvalidToken(status));

      if (status === 200) {
        // Extract moduleId and journeyId from the URL
        // Extract moduleId and journeyId from locPathname
        const pathParts = locPathname.split("/");
        const moduleId = parseInt(
          pathParts[pathParts.indexOf("module") + 1],
          10,
        );
        const journeyId = parseInt(
          pathParts[pathParts.indexOf("module") + 2],
          10,
        );

        // Find the matching data
        const found = data.find(
          (item) =>
            item.module_id === moduleId && item.journey_id === journeyId,
        );

        if (found) {
          setTitleModuleReview(found.module_name);
        }
      }
    } catch (err) {
      console.log("Error fetch List Module Review " + err);
      setTitleModuleReview("");
    } finally {
      setLoadingModuleReview(false);
    }
  };

  const handleRequestChangePassword = async () => {
    const { is_used_sso } = getDataSso();
    if (is_used_sso) {
      const username = getUsername();
      const payloadSend = {
        "username": username
      }

      try {
        const { message, status } = await RequestChangePassword({ data: payloadSend });

      } catch (err) {
        mainState.setMessageSnack(message);
        mainState.setOpenedSnack(true);
      } finally {
        setIsOpenModalSentChangePassword(true)
      }
    } else {
      setModalPassword(true);
    }
  }

  const maskEmailForChangePassword = (emailUser) => {
    if (!emailUser || !emailUser.includes("@")) return emailUser;

    const [username, domain] = emailUser.split("@");

    // Username
    const usernameVisible = username.length <= 4 ? 1 : 4;
    const maskedUsername =
        username.slice(0, usernameVisible) +
        "*".repeat(username.length - usernameVisible);

    // Domain (termasuk .com)
    const domainVisible = Math.min(4, domain.length);
    const maskedDomain =
        domain.slice(0, domainVisible) +
        "*".repeat(domain.length - domainVisible);

    return `${maskedUsername}@${maskedDomain}`;
  }

  useEffect(() => {
    if (isMobileVersion) {
      // Check if the path matches /reviews/module/:moduleId/:journeyId
      const pathParts = locPathname.split("/");
      if (
        pathParts[1] === "reviews" &&
        pathParts[2] === "module" &&
        !isNaN(Number(pathParts[3])) &&
        !isNaN(Number(pathParts[4]))
      ) {
        fetchListModuleReviewed();
        dispatch(setShowDetailsModuleReview(true));
      } else {
        setTitleModuleReview(t("main.sidebar.reviews"));
      }

      return () => {
        // Cleanup function to reset titleModuleReview when leaving the page
        setTitleModuleReview(t("main.sidebar.reviews"));
      };
    }
  }, [navigate]);

  // Redirect to /reviews if refresh on page /reviews/module/:moduleId/:journeyId because state redux reset
  useEffect(() => {
    if (isMobileVersion && !titleModuleReview) {
      const pathParts = locPathname.split("/");
      if (
        pathParts[1] === "reviews" &&
        pathParts[2] === "module" &&
        !isNaN(Number(pathParts[3])) &&
        !isNaN(Number(pathParts[4]))
      ) {
        navigate("/reviews", { replace: true });
        dispatch(setShowDetailsModuleReview(false));
      }
    }
    // eslint-disable-next-line
  }, [titleModuleReview, isMobileVersion]);

  const contentHeaderMobile = {
    home: (
      <Row style={styles.headerMobile} justify={"space-between"}>
        <Col
          span={8}
          style={{
            height: "100%",
            marginRight: "auto",
            flex: "none",
            paddingLeft: 24,
          }}
        >
          <a name="btn-logo-main" onClick={() => navigateUrl("/home")}>
            <img style={{ height: "100%" }} src={WebLogo} alt="Moleawiz Logo" />
          </a>
        </Col>

        <Col span={12}>
          <Row justify={"end"}>
            <Col
              className="learning-point-wrapper"
              style={styles.colRightWrapperMobile}
              onClick={() => handlePointClicked()}
            >
              <img
                src={Learningpoints}
                style={styles.imageLearningPoint}
                alt="Learning Points Mobile"
              />
              <div style={styles.learningPointSkelWrapperMobile}>
                <span style={styles.pointsMobile} className="learning-points">
                  {points === undefined ? (
                    <>
                      <Skeleton.Input active />
                    </>
                  ) : (
                    numberWithDot(points)
                  )}
                </span>
                <span style={styles.textLearningPointsMobile}>
                  {t("main.header.learning_points")}
                </span>
              </div>
            </Col>
          </Row>
        </Col>

        <MenuOutlined
          style={{ color: "black" }}
          onClick={() => dispatch(setCollapsedMenuMobile(true))}
        />
      </Row>
    ),
    "my-learning-journey": (
      <Row style={styles.headerMobile} justify={"space-between"}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            width: hasSearchQuery ? "100%" : "auto",
            height: hasSearchQuery ? "100%" : "auto",
          }}
        >
          <div
            style={{ marginRight: 12, paddingLeft: 24 }}
            onClick={(e) => {
              e.preventDefault();
              navigate(
                !!searchQuery
                  ? hasLengthParam
                    ? `my-learning-journey?search=${searchQuery}`
                    : `my-learning-journey`
                  : `home`,
              );
            }}
          >
            <ArrowLeftOutlined style={{ color: colorTextTitleMobile }} />
          </div>
          {hasSearchQuery ? (
            <SearchMobileVersion
              isContentLibraryPage={hasSearchQuery}
              mainState={mainState}
            />
          ) : (
            <div
              style={{
                fontSize: 16,
                fontWeight: 500,
                color: colorTextTitleMobile,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                width: "auto",
                maxWidth: "250px",
              }}
            >
              <span>{labelHeaderMobileVersion}</span>
            </div>
          )}
        </div>
        {!hasSearchQuery && (
          <>
            <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
              <SearchOutlined
                style={{
                  color: colorTextTitleMobile,
                  fontSize: 18,
                  fontWeight: 500,
                }}
                onClick={(e) => {
                  e.preventDefault();
                  navigate(`/my-learning-journey?search`);
                }}
              />
              <MenuOutlined
                style={{ color: "black", marginLeft: 12 }}
                onClick={() => dispatch(setCollapsedMenuMobile(true))}
              />
            </div>
          </>
        )}
      </Row>
    ),
    leaderboards: (
      <Row style={styles.headerMobile} justify={"space-between"}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <div
            style={{ marginRight: 12, paddingLeft: 24 }}
            onClick={(e) => {
              e.preventDefault();
              navigate(`${locationFrom}`);
            }}
          >
            <ArrowLeftOutlined style={{ color: colorTextTitleMobile }} />
          </div>
          <div
            style={{
              fontSize: 16,
              fontWeight: 500,
              color: colorTextTitleMobile,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              width: "auto",
              maxWidth: "250px",
            }}
          >
            <span>{t("main.sidebar.leaderboards")}</span>
          </div>
        </div>
        <MenuOutlined
          style={{ color: "black" }}
          onClick={() => dispatch(setCollapsedMenuMobile(true))}
        />
      </Row>
    ),
    help: (
      <Row style={styles.headerMobile} justify={"space-between"}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <div
            style={{ marginRight: 12, paddingLeft: 24 }}
            onClick={(e) => {
              e.preventDefault();
              navigate(`${locationFrom}`);
            }}
          >
            <ArrowLeftOutlined style={{ color: colorTextTitleMobile }} />
          </div>
          <div
            style={{
              fontSize: 16,
              fontWeight: 500,
              color: colorTextTitleMobile,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              width: "auto",
              maxWidth: "250px",
            }}
          >
            <span>{t("main.sidebar.help_center")}</span>
          </div>
        </div>
        <MenuOutlined
          style={{ color: "black" }}
          onClick={() => dispatch(setCollapsedMenuMobile(true))}
        />
      </Row>
    ),
    reviews: (
      <Row style={styles.headerMobile} justify={"space-between"}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <div
            style={{ marginRight: 12, paddingLeft: 24 }}
            onClick={(e) => {
              e.preventDefault();
              dispatch(setShowDetailsModuleReview(false));

              isPageReviews
                ? navigate(`${locationFrom}`)
                : navigate("/reviews");
            }}
          >
            <ArrowLeftOutlined style={{ color: colorTextTitleMobile }} />
          </div>
          <div
            style={{
              fontSize: 16,
              fontWeight: 500,
              color: colorTextTitleMobile,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              width: headerWithoutHamburger && "100%",
              maxWidth: headerWithoutHamburger ? "unset" : "250px",
              textWrapMode: "wrap",
            }}
            className={headerWithoutHamburger ? "break-dots-first-line" : ""}
          >
            {isPageReviews ? (
              <span>{t("main.sidebar.reviews")}</span>
            ) : (
              <span>{titleModuleReview}</span>
            )}
          </div>
        </div>
        {isPageReviews && (
          <MenuOutlined
            style={{ color: "black" }}
            onClick={() => dispatch(setCollapsedMenuMobile(true))}
          />
        )}
      </Row>
    ),
    rewards: (
      <Row style={styles.headerMobile} justify={"space-between"}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <div
            style={{ marginRight: 12, paddingLeft: 24 }}
            onClick={(e) => {
              e.preventDefault();
              if (locPathname.includes("history")) {
                navigate("/rewards");
              } else {
                navigate(`${locationFrom}`);
              }
            }}
          >
            <ArrowLeftOutlined style={{ color: colorTextTitleMobile }} />
          </div>
          <div
            style={{
              fontSize: 16,
              fontWeight: 500,
              color: colorTextTitleMobile,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              width: "auto",
              maxWidth: "250px",
            }}
          >
            <span>
              {locPathname.includes("history")
                ? t("main.sidebar.redeem_history")
                : t("main.sidebar.rewards")}
            </span>
          </div>
        </div>
        <MenuOutlined
          style={{ color: "black" }}
          onClick={() => dispatch(setCollapsedMenuMobile(true))}
        />
      </Row>
    ),
    "content-library": (
      <Row style={styles.headerMobile} justify={"space-between"}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            width: hasSearchQuery ? "100%" : "auto",
            height: hasSearchQuery ? "100%" : "auto",
          }}
        >
          <div
            style={{ marginRight: 12, paddingLeft: 24 }}
            onClick={(e) => {
              e.preventDefault();
              if (hasSearchQuery) {
                navigate("/content-library");
              } else {
                navigate(`${locationFrom}`);
              }
            }}
          >
            <ArrowLeftOutlined
              style={{ color: colorTextTitleMobile }}
              onClick={(e) => {
                e.preventDefault();
                if (hasSearchQuery) {
                  navigate("/content-library");
                } else {
                  navigate(`${locationFrom}`);
                }
              }}
            />
          </div>
          {hasSearchQuery ? (
            <SearchMobileVersion
              isContentLibraryPage={hasSearchQuery}
              mainState={mainState}
            />
          ) : (
            <div
              style={{
                fontSize: 16,
                fontWeight: 500,
                color: colorTextTitleMobile,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                width: "auto",
                maxWidth: "250px",
              }}
            >
              <span>{t("main.sidebar.content_library")}</span>
            </div>
          )}
        </div>
        {!hasSearchQuery && (
          <>
            <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
              <SearchOutlined
                style={{
                  color: colorTextTitleMobile,
                  fontSize: 18,
                  fontWeight: 500,
                }}
                onClick={(e) => {
                  e.preventDefault();
                  navigate(`/content-library?search`);
                }}
              />
              <MenuOutlined
                style={{ color: "black", marginLeft: 12 }}
                onClick={() => dispatch(setCollapsedMenuMobile(true))}
              />
            </div>
          </>
        )}
      </Row>
    ),
    "team-monitoring": (
      <Row style={styles.headerMobile} justify={"space-between"}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <div
            style={{ marginRight: 12, paddingLeft: 24 }}
            onClick={(e) => {
              e.preventDefault();
              navigate(-1 || (`${locationFrom}`));
            }}
          >
            <ArrowLeftOutlined style={{ color: colorTextTitleMobile }} />
          </div>
          <div
            style={{
              fontSize: 16,
              fontWeight: 500,
              color: colorTextTitleMobile,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              // width:
              //   locPathname.includes("/team-monitoring/journey/") &&
              //   (screens.xs
              //     ? "calc(100vw - 70px)" // 38px left + 18px right for mobile/tablet
              //     : "calc(100vw - 176px)"), // 58px left + 18px right for desktop
              width: headerWithoutHamburger && "100%",
              maxWidth: headerWithoutHamburger ? "unset" : "250px",
              textWrapMode: "wrap",
            }}
            className={headerWithoutHamburger ? "break-dots-first-line" : ""}
          >
            <span>
              {locPathname === "/team-monitoring/event/detail"
                ? t("feature.feature_tm.calendar")
                : locPathname.includes(
                  "/team-monitoring/learning-status/detail",
                )
                  ? t("feature.feature_tm.learning_status")
                  : locPathname.includes("/team-monitoring/team-profile")
                    ? t("feature.feature_tm.team_profile")
                    : locPathname.includes("/team-monitoring/member/profile")
                      ? t("main.header.dropdown_profile.profile")
                      : locPathname.includes("/team-monitoring/journey/")
                        ? loadingTitleDetailTeamMonitoringOnBoarding ? <Skeleton.Input
                          active
                          style={{
                            width: "100px",
                            marginTop: "18px",
                          }}
                        /> : titleDetailTeamMonitoringOnBoarding
                        : t("main.sidebar.team_monitoring")}
            </span>
          </div>
        </div>
        {locPathname !== "/team-monitoring/event/detail" &&
          !headerWithoutHamburger && (
            <>
              <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    lineHeight: "normal",
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(`/team-monitoring/team-profile`);
                  }}
                >
                  <div>
                    <Image
                      preview={false}
                      src={IcTeamMember}
                      height={24}
                      width={24}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      marginLeft: 4,
                    }}
                  >
                    <div
                      style={{
                        fontSize: "12px",
                        fontWeight: "500",
                        color: colorTextTitleMobile,
                      }}
                    >
                      {loadingTeamLearningStatus ? (
                        <LoadingOutlined style={{ margin: 0 }} spin />
                      ) : (
                        totalDataTeamMember
                      )}
                    </div>
                    <div style={{ fontSize: "10px", color: colorTextDesc }}>
                      {t("feature.feature_tm.member")}
                    </div>
                  </div>
                </div>
                <MenuOutlined
                  style={{ color: "black" }}
                  onClick={() => dispatch(setCollapsedMenuMobile(true))}
                />
              </div>
            </>
          )}
      </Row>
    ),
  }[locPathname.split("/")[1]];

  return (
    <>
      <ConfigProvider
        theme={{
          token: {
            borderRadiusLG: 28,
            fontFamily: "Roboto",
          },
        }}
      >
        {!isMobileVersion ? (
          <Row align={"middle"} style={{ height: "100%" }}>
            <Col span={4} style={{ height: "100%" }}>
              <a name="btn-logo-main" onClick={() => navigateUrl("/home")}>
                <img
                  style={styles.floatLeft}
                  src={WebLogo}
                  alt="Moleawiz Logo"
                />
              </a>
            </Col>
            <Col span={11}>
              {journeyId !== null && loading === false ? (
                <div style={styles.titleProgramWrapper}>
                  <a
                    className="title-program-header"
                    style={styles.titleProgram}
                    onClick={() => removeHighlight()}
                  >
                    {journeyName}
                  </a>
                </div>
              ) : pageName !== null && loading === false ? (
                <div
                  text-title="text-title-help-center"
                  style={styles.pageNameStyle}
                >
                  {pageName}
                </div>
              ) : locPathname.indexOf("my-learning-journey/journey") > -1 ||
                locPathname.indexOf("/help") > -1 ? (
                <div style={styles.titleProgramSkelWrapper}>
                  <Skeleton.Input
                    active
                    size={26}
                    style={styles.titleProgramSkel}
                  />
                </div>
              ) : (
                <></>
              )}
              {contentLibraryAcademyHeader === true ? (
                <div style={styles.titleProgramWrapper}>
                  <Tag
                    bordered={false}
                    style={{
                      background: ColorSecondary,
                      color: ColorPrimary,
                      fontSize: 10,
                      fontWeight: 500,
                      lineHeight: "normal",
                      padding: "3px 4px",
                    }}
                  >
                    {academyNameHeader !== undefined &&
                      checkTagName(academyNameHeader.split("_")[0])}
                  </Tag>
                  <a
                    className="title-program-header"
                    style={styles.titleProgram}
                    onClick={() => backToAcademy()}
                  >
                    {academyNameHeader !== undefined &&
                      academyNameHeader.split("_")[1]}
                  </a>
                </div>
              ) : (
                <></>
              )}
              {searchBarPage !== "" ? (
                <div
                  className="search-bar"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Tooltip
                    placement="bottomLeft"
                    title={tooltipMessage}
                    open={isOpenTooltipToolbar}
                    arrow
                    align={{ offset: [15, 10] }}
                    getPopupContainer={(trigger) => {
                      return trigger;
                    }}
                  >
                    <AutoComplete
                      // optionLabelProp="value"
                      className="search-bar-autocomplete"
                      showSearch
                      size="middle"
                      placeholder={t("feature.feature_search.what_do_you")}
                      allowClear={<CloseOutlined />}
                      suffixIcon={<SearchOutlined style={{ fontSize: 14 }} />}
                      style={{
                        width: "100%",
                        textAlign: "left",
                      }}
                      onSelect={handleSelectSearchBar}
                      onSearch={handleOnSearch}
                      onKeyDown={handleEnter}
                      onFocus={handleFocus}
                      onBlur={() => setIsOpenSelect(false)}
                      searchValue={valueSearch}
                      autoClearSearchValue={false}
                      filterOption={false}
                      maxLength={50}
                      open={isOpenSelect}
                      dropdownStyle={{
                        marginTop: isOpenTooltipToolbar ? 43 : 0, // stack tooltip in middle
                      }}
                    >
                      {itemsSearchBar !== undefined &&
                        itemsSearchBar.map((task, index) => {
                          return (
                            <Option
                              key={index}
                              value={task.value}
                              label={task.label}
                            >
                              <span>{task.label}</span>
                              <span style={{ float: "right" }}>
                                <CloseOutlined
                                  style={{
                                    width: 8,
                                    height: 8,
                                  }}
                                  onClick={(e) => {
                                    e.stopPropagation(); /* Add e.stopPropagation() */
                                    deleteOption(task.value);
                                  }}
                                />
                              </span>
                            </Option>
                          );
                        })}
                    </AutoComplete>
                  </Tooltip>
                </div>
              ) : (
                <></>
              )}
            </Col>
            <Col span={9}>
              <Row justify={"end"}>
                <Col
                  className="learning-point-wrapper"
                  style={styles.colRightWrapper}
                  onClick={() => handlePointClicked()}
                >
                  <img
                    src={Learningpoints}
                    style={styles.imageLearningPoint}
                    alt="Learning Points"
                  />
                  <div style={styles.learningPointSkelWrapper}>
                    <span style={styles.points} className="learning-points">
                      {points === undefined ? (
                        <>
                          <Skeleton.Input active />
                        </>
                      ) : (
                        numberWithDot(points)
                      )}
                    </span>
                    <span style={styles.textLearningPoints}>
                      {t("main.header.learning_points")}
                    </span>
                  </div>
                </Col>
                <Col style={styles.colDropdownMenu}>
                  {/* <img src={IProfile} alt="Icon Profile" /> */}
                  <UncontrolledDropdown
                    id="header-dpd"
                    className="dropdown header-option"
                  >
                    <DropdownToggle
                      tag="button"
                      className="nav-link p-0"
                      data-bs-toggle="dropdown"
                      name="dropdown-user-profile"
                      onClick={() => setFlagDropDown(!flagDropDown)}
                    >
                      {name === undefined ? (
                        <>
                          <Skeleton.Avatar active size={32} />
                        </>
                      ) : (
                        <>
                          <Avatar
                            size={32}
                            src={picture}
                            style={{
                              backgroundColor: colorPhotoProfileUserHeader,
                              border: "none",
                            }}
                          >
                            {firstname &&
                              Array.from(firstname)[0].toUpperCase()}
                          </Avatar>
                        </>
                      )}
                      <div style={styles.nameWrapper}>
                        <span style={styles.textName}>
                          {name === undefined ? (
                            <>
                              <Skeleton.Input active />
                            </>
                          ) : (
                            name
                          )}
                        </span>
                      </div>
                      {!flagDropDown ? (
                        <DownOutlined style={styles.downOutlineStyle} />
                      ) : (
                        <UpOutlined style={styles.upOutlineStyle} />
                      )}
                    </DropdownToggle>
                    <DropdownMenu
                      ref={mutation}
                      className="transform-3d-left min-width-216 dropdown-menu dropdown-menu-end dropdown-menu-arrow animated dropdown-custom"
                    >
                      <DropdownItem
                        className="dropdown-item d-flex padding-23"
                        style={styles.dropDownItem}
                        name="btn-profile-user-profile"
                        onMouseOver={() => setMouseOver("profile")}
                        onMouseLeave={() => setMouseOver("")}
                        onClick={() => {
                          setMouseOver("");
                          navigateUrl("/profile");
                        }}
                      >
                        <div className="ms-2" style={styles.fontSize14}>
                          <IProfile mouseOv={mouseOver} />
                          <span className="text-dpd">
                            {t("main.header.dropdown_profile.profile")}
                          </span>
                        </div>
                      </DropdownItem>
                      {
                        remoteProperty !== undefined && remoteProperty !== null ?
                          remoteProperty.showChangePassword == null || remoteProperty.showChangePassword == undefined || remoteProperty.showChangePassword == true ?
                            <DropdownItem
                              className="dropdown-item d-flex padding-23"
                              style={styles.styleDpd}
                              onClick={() => {
                                handleRequestChangePassword();
                                setMouseOver("");
                              }}
                              name="btn-change-password-user-profile"
                              onMouseOver={() => setMouseOver("change-password")}
                              onMouseLeave={() => setMouseOver("")}
                            >
                              <div className="ms-2" style={styles.fontSize14}>
                                <IChangePassword mouseOv={mouseOver} />
                                <span className="text-dpd">
                                  {t("main.header.dropdown_profile.change_password")}
                                </span>
                              </div>
                            </DropdownItem>
                          :
                            <></>
                        :
                        <></>
                      }
                      <DropdownItem
                        className="dropdown-item d-flex padding-23"
                        style={styles.styleDpd}
                        onClick={() => {
                          setIsOpenModalChangeLanguage(true);
                          setMouseOver("");
                        }}
                        name="btn-change-language-user-profile"
                        onMouseOver={() => setMouseOver("language")}
                        onMouseLeave={() => setMouseOver("")}
                      >
                        <div className="ms-2" style={styles.fontSize14}>
                          <GlobalOutlined
                            style={{
                              color:
                                mouseOver !== "language"
                                  ? "#AAAAAD"
                                  : ColorPrimary,
                              fontSize: 18,
                              marginRight: 14,
                            }}
                          />
                          <span className="text-dpd">
                            {t("main.header.dropdown_profile.change_language")}
                          </span>
                        </div>
                      </DropdownItem>
                      <DropdownItem
                        className="dropdown-item d-flex padding-23"
                        style={styles.styleDpd}
                        onClick={() => {
                          setModalLogout(true);
                          setMouseOver("");
                        }}
                        name="btn-logout-user-profile"
                        onMouseOver={() => setMouseOver("logout")}
                        onMouseLeave={() => setMouseOver("")}
                      >
                        <div className="ms-2" style={styles.fontSize14}>
                          <ILogout mouseOv={mouseOver} />
                          <span className="text-dpd">
                            {t("main.header.dropdown_profile.logout")}
                          </span>
                        </div>
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </Col>
              </Row>
            </Col>
          </Row>
        ) : (
          //mobile version
          contentHeaderMobile
        )}

        <Modal
          open={isOpenModalSentChangePassword}
          maskClosable="false"
          closeIcon={false}
          width={420}
          centered
          footer={null}>
          <div style={{ textAlign: 'center', padding: '32px' }}>
              <div style={{ fontSize: '22px', color: textTitleHome, marginBottom: 16, fontWeight: '500' }}>
                  Email Sent
              </div>
              <p style={{ color: textTitleHome }}>
                  A link has been sent to <span style={{fontWeight:"bold"}}>{maskEmailForChangePassword(email)}</span> to reset your password.
              </p>
              <Button
                  className="btn btn-sm btn-primary btn-block"
                  style={{ borderRadius: '6px', border: 'none', fontWeight: '500', marginTop: '30px', height: '48px' }}
                  name="btn-ok-invalid"
                  onClick={() => setIsOpenModalSentChangePassword(false)}>
                  OK
              </Button>
          </div>
      </Modal>

        <LogOut
          openModalLogout={openModalLogout}
          setModalLogout={setModalLogout}
          handleLogOutClick={handleLogOutClick}
        />

        <ChangePassword
          openModalPassword={openModalPassword}
          setModalPassword={setModalPassword}
          setModalSuccessPassword={setModalSuccessPassword}
        />

        <ModalSuccessCheck
          mainState={undefined}
          confirmRating={false}
          textTitle={t(
            "feature.home.pop_up_change_password.password_successfully_changed",
          )}
          textDesc={t(
            "feature.home.pop_up_change_password.please_use_new_password_next_login",
          )}
          modalSuccess={modalSuccessPassword}
          setModalSuccess={setModalSuccessPassword}
        />

        <ModalPointHistory
          isOpenPointHistory={isOpenPointHistory}
          setIsOpenPointHistory={setIsOpenPointHistory}
          pointHistoryData={pointHistoryData}
          setPointHistoryData={setPointHistoryData}
          points={points}
          dateModuleConvert={dateModuleConvert}
          isMobileVersion={isMobileVersion}
        />

        <ModalChangeLanguage
          ti18n={t}
          i18n={i18n}
          setIsOpenModalChangeLanguage={setIsOpenModalChangeLanguage}
          isOpenModalChangeLanguage={isOpenModalChangeLanguage}
          setMessageSnack={mainState.setMessageSnack}
          setOpenedSnack={mainState.setOpenedSnack}
        />
      </ConfigProvider>
    </>
  );
};

export default HeaderContent;
